import React, { useState } from 'react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente via email dopo il pagamento. Ricevi un link per scaricare tutti gli 8 volumi e i bonus.'
}, {
  q: 'È adatto per classi con diversi livelli?',
  a: 'Sì, gli esercizi sono graduati (Base, Intermedio, Avanzato) per permetterti di differenziare la didattica.'
}, {
  q: 'I materiali sono stampabili?',
  a: 'Certamente. Tutti i file sono PDF ad alta risoluzione pronti per la stampa o la proiezione su LIM.'
}, {
  q: 'La valutazione è conforme alle linee guida MIUR?',
  a: 'Sì, le rubriche e le checklist seguono le normative vigenti per la scuola secondaria italiana.'
}, {
  q: 'Per quali classi è pensato il kit?',
  a: 'Il percorso copre sia la scuola secondaria di primo grado (medie) sia il biennio della secondaria di secondo grado (superiori), con contenuti progressivi e adattabili.'
}, {
  q: 'Posso utilizzarlo anche con studenti DSA o BES?',
  a: 'Sì. Il Manuale Recupero & Inclusione contiene materiali specifici, mappe concettuali e schede semplificate pensate per studenti con DSA, BES e bisogni educativi speciali.'
}, {
  q: 'Quanto tempo ho per scaricare i materiali?',
  a: "L'accesso è permanente. Una volta acquistato, puoi scaricare i file quando vuoi senza scadenza e conservarli sul tuo dispositivo."
}, {
  q: 'Posso usare i contenuti per più anni scolastici?',
  a: 'Assolutamente sì. La licenza ti permette di utilizzare i materiali nelle tue classi per tutti gli anni che vorrai, senza costi aggiuntivi.'
}, {
  q: 'Come funziona la garanzia di 14 giorni?',
  a: "Se entro 14 giorni dall'acquisto non sei soddisfatto, ti rimborsiamo l'intero importo. Basta scriverci una email, senza domande e senza complicazioni."
}, {
  q: 'Quali metodi di pagamento accettate?',
  a: 'Accettiamo tutte le principali carte di credito e debito (Visa, Mastercard, American Express), oltre a PayPal. Il pagamento è unico e sicuro tramite circuito protetto.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-184">
          Domande Frequenti
        </h2>

        <div className="space-y-4 mb-16" data-id="element-185">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-186">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-187">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-188">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-189">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-190">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-191">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-192">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-193"></div>
          <a href="#pricing" className="btn-cta btn-primary-pulse text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 inline-block mb-4 w-full sm:w-auto max-w-2xl text-center" data-id="element-194">
            <span className="relative z-10" data-id="element-195">
              💪 SÌ! VOGLIO RIVOLUZIONARE LE MIE LEZIONI ORA
            </span>
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-196">
            <span data-id="element-197">⚡ Accesso Immediato</span>
            <span data-id="element-198">•</span>
            <span data-id="element-199">🛡️ Garanzia di 14 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}